module.exports = __webpack_public_path__ + "img/NormalSeat_BordeauxMetallic.d61986dd.png";